import { IColumnSort } from './sdc-state.typings';

export const DEFAULT_SORT: IColumnSort[] = [
  { colId: 'status', sort: 'asc' },
  { colId: 'cohort', sort: 'asc' },
  { colId: 'studentName', sort: 'asc' },
];
